module.exports = __webpack_public_path__ + "img/drag-handle.e4ecc8cc.svg";